module.exports = __webpack_public_path__ + "media/addidas.ce5c5bf2.mp4";